module.exports = __webpack_public_path__ + "plate.jpg?0461482dd9dda7fa2f829d16f431a690";